import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// import vuex modules
import auth from "./modules/auth";
import wishlist from "./modules/wishlist";
import compare from "./modules/compare";
import solutions from "./modules/solutions";
import consentcookie from "./modules/cookieconsent";
import manufacturers from "./modules/manufacturers";
import outofstock from "./modules/outofstock";
import cart from "./modules/cart";

// create store
export default new Vuex.Store({
    modules: {
        auth,
        wishlist,
        compare,
        manufacturers,
        solutions,
        consentcookie,
        outofstock,
        cart,
    },
    plugins: [
        createPersistedState({
            paths: [
                "wishlist.list",
                "wishlist.cartcount",
                "compare.list",
                "auth.profile",
                "solutions",
                "consentcookie.cookieConsent",
            ]
        })
    ],
    state: {},
    mutations: {}
});